import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  inject,
  viewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Observable, finalize, takeUntil, tap } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  ComparisonOperator,
  GetEnumValuesDto,
  GetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto,
  GetSmartSmsRequestByIdDto,
  GetSmartSmsRequestByIdForDetailDto,
  GetSmartSmsRequestRecipientsByRequestIdDto,
  GetSmartSmsRequestsWithPaginationDto,
  PaginatedListOfGetSmartSmsRequestsWithPaginationDto,
  SmartSmsRequestStatus,
} from 'src/app/core/api/models';
import {
  ExcelService,
  SmartSmsRequestsService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { DefaultSearchValueService } from 'src/app/core/services/default-search-value.service';
import { DialogStatus } from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { SmartSmsShareMemoryService } from 'src/app/core/services/smart-sms-shareMemory.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { CreateSmartSmsRequestExcelDialogComponent } from './create-smart-sms-request-excel/create-smart-sms-request-excel-dialog.component';
import { SmartSmsImportRequestNameDialog } from './import-request-dialog/smart-sms-import-request';

@Component({
  selector: 'app-send-smart-sms-request-list',
  templateUrl: './send-smart-sms-request-list.html',
  standalone: false,
})
export class SendSmartSmsRequestListComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties0

  pageName = 'smartSmsRequests';
  pageId = 'smartSmsRequest';
  protected currentService = inject(SmartSmsRequestsService);
  /* Binding service endpoints */
  paginationApiMethodName: string =
    this.currentService.smartSmsRequestsGetSmartSmsRequestsWithPagination.name;
  modelWithPagination$: Observable<PaginatedListOfGetSmartSmsRequestsWithPaginationDto>;
  items$: Observable<Array<GetSmartSmsRequestsWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};
  SmartSmsStatusTypesEnumValues: GetEnumValuesDto[] = [];
  CreationLocationEnumValues: GetEnumValuesDto[] = [];
  isShowDetailPage: boolean = false;
  isShowReportPage: boolean = false;
  isEnablePauseStatus: boolean = false;
  isEnablePlayStatus: boolean = false;
  detailPageModel: Array<GetSmartSmsRequestRecipientsByRequestIdDto> = [];
  smartSmsRequestId;
  campaignTitle;
  public showExportItems: boolean = true;
  isPeriodic: boolean;
  isShowRequestDetailPage: boolean = false;
  requestDetailPageModel: GetSmartSmsRequestByIdForDetailDto;
  setItemActiveStatusSelectedIds: number[] = [];
  selectedItemsList: GetSmartSmsRequestsWithPaginationDto[] = [];
  get SmartSmsRequestStatus() {
    return SmartSmsRequestStatus;
  }
  reportModel: GetPeriodicSmartSmsRequestStatisticsWithRequestDetailsDto;

  //#endregion

  constructor(
    public dynamicTabService: DynamicTabService,
    public smartSmsShareMem: SmartSmsShareMemoryService,
    protected translate: TranslateService,

    public dialog: MatDialog,
    protected renderer: Renderer2,
    public excelFileService: ExcelService,
    protected defaultSearchValueService: DefaultSearchValueService
  ) {
    super();
  }

  //#region init methods
  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showAddBtn = false;
      // this.onShowSmartReqStatisticWithRequestDetailsApi(4692);
      if (this.defaultSearchValueService.isFromDashboardtoSmartSmsRequest)
        this.setFiltersForDashboard();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.RequestDetails_key)
        this.onShowRequestDetails(+value, false);
      if (key == QueryStringTypesEnum.Report_key)
        this.onShowSmartReqStatisticWithRequestDetailsApi(+value, false, false);
    }
  }

  getTableData() {
    super.getTableData();
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmartSmsRequestStatus')
      .pipe(this.basePipeOperators())
      .subscribe((values) => (this.SmartSmsStatusTypesEnumValues = values));
    this.getEnumValuesApi('EntityCreationLocation')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.CreationLocationEnumValues = values));
    return this.SmartSmsStatusTypesEnumValues;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: ``,
        name: '',
        hasSearch: false,
        noSorting: true,
        isCheckBox: true,
        wrap: true,
      },
      {
        title: this.localizer.id,
        name: 'id',
        hasSearch: true,
        type: 'number',
        noNumberSeparator: true,
        wrap: true,
      },
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: 'common.campaign',
        name: 'isPeriodic',
        type: 'boolean',
        hasSearch: true,
        wrap: true,
      },
      { title: this.localizer.userName, name: 'userName', hasSearch: true },
      {
        title: this.localizer.organizationName,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}status`,
        name: 'status',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmartSmsRequestStatus',
      },
      {
        title: 'common.creationLocation',
        name: 'creationLocation',
        hasSearch: true,
        type: 'enum',
        enumName: 'EntityCreationLocation',
        wrap: true,
      },
      {
        title: 'common.startLocation',
        name: 'startLocation',
        hasSearch: true,
        type: 'enum',
        enumName: 'EntityCreationLocation',
        wrap: true,
      },
      {
        title: `${this.tableVocabs}statusDatetime`,
        name: 'statusDatetime',
        hasSearch: true,
        type: 'dateTime',
      },

      {
        title: `${this.tableVocabs}startDatetime`,
        name: 'startDatetime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: `${this.tableVocabs}endDatetime`,
        name: 'endDatetime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }
  //#endregion

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();
    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .smartSmsRequestsGetSmartSmsRequestById({ SmartSmsRequestId: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //Get update campaign
  updatePeriodicSmartSmsApi(
    model: GetSmartSmsRequestsWithPaginationDto,
    tabName
  ): void {
    this.currentService
      .smartSmsRequestsUpdatePeriodicSmartSmsRequestGet({
        SmartSmsRequestId: model.id,
      })
      .subscribe((result) => {
        if (result) {
          try {
            this.currentDateTime = new Date(
              new Date().getTime() - new Date().getTimezoneOffset() * 60000
            ).toISOString();

            if (result?.data?.periodEnd > this.currentDateTime) {
              this.showParent = false;
              this.setParentQueryString();
              this.dynamicTabService.setNewTab('');
              this.dynamicTabService.setNewTab(tabName);
              this.smartSmsShareMem.setScheduledMessageId(model.id);
              this.smartSmsShareMem.setScheduledMessageTitle(model.title);
              this.smartSmsShareMem.setUpdatePeriodicSmartSmsModel(
                result?.data
              );
              this.smartSmsShareMem.setIsPeriodic(true);
              this.dynamicTabService.setActiveTab(tabName);
            } else {
              const invalidDateErrMsg = this.translate.instant(
                'messages.invalidDateErrorMsgInSend'
              );

              this.dialogService.openDialog({
                title: 'common.error',
                message: invalidDateErrMsg,
                status: DialogStatus.error,
              });
            }
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.smartSms
            );
          }
        }
      });
  }

  deleteSmartSmsRequestByIdListApi(ids: number[]) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.lastSelectedItemId = ids;

    this.currentService
      .smartSmsRequestsDelete({ body: { ids: ids } })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.selectedIds = [])),
        tap((res) => {
          if (res?.isSucceed) this.selectedIds = [];
        })
      )
      .subscribe(this.baseGroupDeleteObserver);
  }

  onShowRequestDetails(id: number, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.RequestDetails_key +
          '=' +
          id
      );
    }
    this.unSubs();
    this.currentService
      .smartSmsRequestsGetSmartSmsRequestByIdForDetail({
        SmartSmsRequestId: id,
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        this.smartSmsShareMem.setScheduledMessageId(id);
        this.requestDetailPageModel = result?.data;
        this.smartSmsRequestId = id;
        this.isShowRequestDetailPage = true;
      });
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();
    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;
    this.selectedIds = [];
    this.selectedIds.push(id);

    this.currentService
      .smartSmsRequestsDelete({ body: { ids: this.selectedIds } })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  groupSetItemActiveStatusApi(ids: number[], active) {
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .smartSmsRequestsUpdateSmartSmsRequestIsActive({
        body: { ids: ids, isActive: active },
      })
      .pipe(
        this.basePipeOperators(),
        tap((res) => {
          if (res?.isSucceed) {
            this.setItemActiveStatusSelectedIds = [];
            this.selectedIds = [];
          }
        })
      )
      .subscribe(this.baseObserver);
  }

  createSmartSmsRequestExcelReportApi() {
    this.excelFileService
      .excelCreateSmartSmsRequestsExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}smartSmsRequestExcel`,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
          };

          const modalResult = this.dialogService.openModal({
            component: CreateSmartSmsRequestExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  onSetItemActiveStatus(
    model: GetSmartSmsRequestsWithPaginationDto,
    active: boolean
  ) {
    this.setItemActiveStatusSelectedIds = [];
    this.setItemActiveStatusSelectedIds.push(model.id);

    this.currentService
      .smartSmsRequestsUpdateSmartSmsRequestIsActive({
        body: {
          ids: this.setItemActiveStatusSelectedIds,
          isActive: active,
        },
      })
      .pipe(
        this.basePipeOperators(),
        tap((res) => {
          if (res?.isSucceed) {
            this.setItemActiveStatusSelectedIds = [];
          }
        })
      )
      .subscribe(this.baseObserver);
  }

  onConfirmSmartSms(
    model: GetSmartSmsRequestsWithPaginationDto,
    tabName,
    index
  ) {
    this.smartSmsShareMem.setUpdatePeriodicSmartSmsModel(null);
    if (model.isPeriodic == false) {
      this.currentService
        .smartSmsRequestsRefreshSmartSmsRequestStatus({
          body: { id: model.id },
        })
        .subscribe((result) => {
          if (result.isSucceed) {
            let _status = Number(result.data) as SmartSmsRequestStatus;
            if (_status != model.status) {
              model.status = _status;
              this.items$[index].status = _status;
              this.cd.detectChanges();
            }
            if (
              _status == SmartSmsRequestStatus.Done ||
              _status == SmartSmsRequestStatus.PartOfRequestIsCompleted
            ) {
              this.setConfirmTab(tabName, model);
            }
          }
        });
    } else {
      this.setConfirmTab(tabName, model);
    }
  }

  setConfirmTab(tabName, model: GetSmartSmsRequestsWithPaginationDto) {
    //todo remove localStorage.setItem
    localStorage.setItem('sendSmartSms', JSON.stringify(model));
    this.showParent = false;
    this.setParentQueryString();
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab(tabName);
    this.smartSmsShareMem.setScheduledMessageId(model.id);
    this.smartSmsShareMem.setScheduledMessageTitle(model.title);
    this.smartSmsShareMem.setIsPeriodic(model.isPeriodic);
    this.dynamicTabService.setActiveTab(tabName);
  }

  onRefreshRow(model: GetSmartSmsRequestByIdDto, index) {
    this.pageConfig.loading = true;
    this.currentService
      .smartSmsRequestsRefreshSmartSmsRequestStatus({
        body: { id: model.id },
      })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => {
          this.pageConfig.loading = false;
        })
      )
      .subscribe((result) => {
        if (result.isSucceed) {
          try {
            let element = document.getElementById('status' + index);
            let enums = this.getEnumsValues();
            let newStatus = enums.find(
              (item) => item.key == Number(result.data)
            )?.value;
            var _status = Number(result.data) as SmartSmsRequestStatus;
            if (_status != model.status) {
              model.status = _status;
              this.items$[index].status = _status;
              this.cd.detectChanges();
            }
          } catch (error) {
            this.loggerService.logError(
              this.tagName,
              error,
              EventTypes.smartSms
            );
          }
        }
      });
  }

  onExportStatus(requestId: number) {
    this.currentService
      .smartSmsRequestsDownLoadSmartSmsRequestStatusResultPost({
        body: {
          smartSmsRequestId: requestId,
        },
      })
      .subscribe((result) => {
        const blob = new Blob([result?.data], { type: 'text/plain' });
        let url = window.URL.createObjectURL(blob);

        let a = this.renderer.createElement('a');
        this.renderer.appendChild(document.body, a);
        this.renderer.setProperty(a, 'style', 'display: none');
        this.renderer.setProperty(a, 'href', url);
        this.renderer.setProperty(
          a,
          'download',
          'smart-request-status-' + requestId.toString() + '.txt'
        );
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }

  onExportRequestClick(requestId: number) {
    this.currentService
      .smartSmsRequestsDownloadCreateSmartSmsRequestPost({
        body: {
          smartSmsRequestId: requestId,
        },
      })
      .subscribe((result) => {
        //info:standard solution
        const blob = new Blob([result?.data], { type: 'text/plain' });
        let url = window.URL.createObjectURL(blob);
        let a = this.renderer.createElement('a');
        this.renderer.appendChild(document.body, a);
        this.renderer.setStyle(a, 'display', 'none');
        this.renderer.setProperty(a, 'href', url);
        this.renderer.setProperty(
          a,
          'download',
          'smart-request-' + requestId.toString() + '.txt'
        );
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
  }

  importRequestStatusFromFileChange(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    if (fileList) {
      this.currentService
        .smartSmsRequestsRefreshSmartSmsRequestStatusByFilePost({
          body: {
            File: fileList[0],
            SmartSmsRequestId: this.statusRequestId,
          },
        })
        .subscribe(this.baseObserver);
    }
  }

  importRequestFromFileChange(event: Event) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;
    var dlg = this.dialog;
    var smartSmsService = this.currentService;

    if (fileList) {
      const dialogRef = dlg.open(SmartSmsImportRequestNameDialog, {
        width: '250px',
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result != '')
          smartSmsService
            .smartSmsRequestsCreateSmartSmsRequestByFilePost({
              body: {
                File: fileList[0],
                Title: result,
              },
            })
            .subscribe(this.baseObserver);
      });
    }
  }
  //#endregion

  //#region group Deletion
  callGroupDeletion() {
    this.deleteSmartSmsRequestByIdListApi(this.selectedIds);
    this.cd.detectChanges();
  }
  //#endregion

  onShowDetails(id, title, isPeriodic) {
    this.showParent = false;
    this.setParentQueryString();
    this.smartSmsShareMem.setScheduledMessageId(id);
    this.smartSmsShareMem.setScheduledMessageTitle(title);
    this.smartSmsShareMem.setIsPeriodic(isPeriodic);
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab('smartDetail');
    this.dynamicTabService.setActiveTab('smartDetail');
  }

  onShowSmartReqStatisticWithRequestDetailsApi(
    id,
    isPeriodic: boolean,
    setUrl = true
  ) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Report_key +
          '=' +
          id
      );
    }
    this.unSubs();
    this.pageConfig.loading = true;

    this.currentService
      .smartSmsRequestsGetPeriodicSmartSmsRequestStatisticsWithRequestDetails({
        SmartSmsRequestId: id,
      })
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.isPeriodic = isPeriodic;
        this.isShowReportPage = true;
        this.reportModel = res?.data;
      });
  }

  callGroupSetItemActiveStatus(active: boolean) {
    this.groupSetItemActiveStatusApi(
      this.setItemActiveStatusSelectedIds,
      active
    );
    this.cd.detectChanges();
  }

  onSendP2PSmart(requestId, tabName) {
    this.showParent = false;
    this.setParentQueryString();
    this.dynamicTabService.setNewTab('');
    this.dynamicTabService.setNewTab(tabName);
    this.smartSmsShareMem.setScheduledMessageId(requestId);
    this.dynamicTabService.setActiveTab('');
    this.dynamicTabService.setActiveTab(tabName);
  }

  getDoneStatus() {
    return SmartSmsRequestStatus.Done;
  }

  //#endregion

  //#region export-import methods

  readonly importRequestFile = viewChild<ElementRef>('importRequestFile');
  readonly importStatusFileInput = viewChild<ElementRef>(
    'importStatusFileInput'
  );
  // importRequestFromFile() {
  //   (this.importRequestFile.nativeElement as HTMLInputElement).value = '';
  //   this.importRequestFile.nativeElement.click();
  // }

  statusRequestId: number = -1;
  importStatusFromFile(requestId: number) {
    // (this.importStatusFileInput.nativeElement as HTMLInputElement).value = '';
    const importStatusFileInput = this.importStatusFileInput();
    this.renderer.setProperty(
      importStatusFileInput.nativeElement as HTMLInputElement,
      'value',
      ''
    );

    importStatusFileInput.nativeElement.click();
    this.statusRequestId = requestId;
  }

  //#endregion

  onUpdatePeriodicSmartSms(id, tabName) {
    this.updatePeriodicSmartSmsApi(id, tabName);
  }

  isShowRequestReport(startDatetime, endDatetime, isPeriodic): boolean {
    let isValidStartDate = DateTimeService.isValidUtcDateTime(startDatetime);
    let isValidEndDate = DateTimeService.isValidUtcDateTime(endDatetime);
    if (isValidStartDate && isValidEndDate) return true;
    return false;
  }

  onAddSelectedId(
    event,
    selectedItem: GetSmartSmsRequestsWithPaginationDto,
    element
  ) {
    try {
      this.isEnablePauseStatus = false;
      this.isEnablePlayStatus = false;

      const checkBoxAllElement =
        this.elementRef.nativeElement.querySelectorAll(`.select-all`);

      let checked = event?.target?.checked;
      if (!selectedItem.id) return;

      if (checked) {
        //add
        this.isSelectAll(checkBoxAllElement);
        if (this.selectedIds?.find((id) => id === selectedItem.id)) return;
        this.selectedIds?.push(selectedItem.id);
        this.selectedItemsList.push(selectedItem);
        if (
          this.setItemActiveStatusSelectedIds?.find(
            (id) => id === selectedItem.id
          )
        )
          return;
        if (selectedItem.isPeriodic)
          this.setItemActiveStatusSelectedIds?.push(selectedItem.id);

        (element as HTMLElement).classList.add('row-active');
      } else {
        //remove
        const id = this.selectedIds?.findIndex((id) => id === selectedItem.id);
        if (id != -1) {
          this.selectedIds?.splice(id, 1);
          this.selectedItemsList = this.selectedItemsList.filter(
            (item) => item.id !== selectedItem.id
          );
        }

        const itemActiveStatusId =
          this.setItemActiveStatusSelectedIds?.findIndex(
            (id) => id === selectedItem.id
          );
        if (itemActiveStatusId != -1)
          this.setItemActiveStatusSelectedIds?.splice(itemActiveStatusId, 1);

        (element as HTMLElement).classList.remove('row-active');
        if ((checkBoxAllElement[0] as HTMLInputElement).checked)
          this.unCheckSelectAll();
      }
      if (
        this.selectedItemsList.some(
          (item) => item.status == SmartSmsRequestStatus.Active
        )
      ) {
        this.isEnablePauseStatus = true;
      }
      if (
        this.selectedItemsList.some(
          (item) => item.status == SmartSmsRequestStatus.InActive
        )
      ) {
        this.isEnablePlayStatus = true;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  setFiltersForDashboard() {
    this.comparisonObjects.push(
      {
        field: 'IsActive',
        operator: ComparisonOperator.EqualTo,
        value: true,
      },
      {
        field: 'IsPeriodic',
        operator: ComparisonOperator.EqualTo,
        value: true,
      },
      {
        field: 'OrganizationId ',
        operator: ComparisonOperator.EqualTo,
        value: this.currentUserInfo?.organizationId,
      },
      {
        field: 'EndDatetime ',
        operator: ComparisonOperator.GreaterThan,
        value: DateTimeService.getTodayDate(),
      }
    );
  }

  onExcelReport() {
    this.createSmartSmsRequestExcelReportApi();
  }
  
}
